import { apiService } from '../api';
import { Purchase, CreatePurchaseRequest, PurchaseFilters, RecordPaymentRequest, SupplierOutstandingRow } from '../../types/inventory';

const BASE = '/inventory/purchases';

export const purchaseService = {
  async getPurchases(filters: PurchaseFilters): Promise<Purchase[]> {
    const response = await apiService.get<Purchase[]>(BASE, filters);
    return response.data;
  },

  async getPurchase(id: string): Promise<Purchase> {
    const response = await apiService.get<Purchase>(`${BASE}/${id}`);
    return response.data;
  },

  async createPurchase(data: CreatePurchaseRequest): Promise<Purchase> {
    const response = await apiService.post<Purchase>(BASE, data);
    return response.data;
  },

  async updatePurchase(id: string, data: Partial<CreatePurchaseRequest>): Promise<Purchase> {
    const response = await apiService.put<Purchase>(`${BASE}/${id}`, data);
    return response.data;
  },

  // Mark goods as received — increases stock and writes PURCHASE_IN movements
  async receivePurchase(id: string): Promise<Purchase> {
    const response = await apiService.post<Purchase>(`${BASE}/${id}/receive`);
    return response.data;
  },

  async cancelPurchase(id: string): Promise<Purchase> {
    const response = await apiService.post<Purchase>(`${BASE}/${id}/cancel`);
    return response.data;
  },

  async deletePurchase(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`);
  },

  // Record a payment to the supplier against this purchase
  async recordPayment(id: string, data: RecordPaymentRequest): Promise<Purchase> {
    const response = await apiService.post<Purchase>(`${BASE}/${id}/payments`, data);
    return response.data;
  },

  // Outstanding payables grouped by supplier
  async getPayables(org: string, restaurantId?: string): Promise<SupplierOutstandingRow[]> {
    const response = await apiService.get<SupplierOutstandingRow[]>(`${BASE}/payables`, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },
};
